import BreadcrumbsWrapper from "../../components/breadcrumbs/BreadcrumbsWrapper";
import React from "react";
import {Container, DownloadButton, DownloadIcon, HeaderWrapper} from "./Kpi.css";
import {Icon, theme} from "@elcimai/webankdesignsystem";

function Kpi(){

    let currentHost = `${window.location.hostname}`;
    const knownHost = ["webline-recette.montepaschi-banque.fr", "ewebline.montepaschi-banque.fr"]
    if(!knownHost.includes(currentHost)){
        currentHost = knownHost[0];
    }
    

    return(
        <div className={Container}>
            <BreadcrumbsWrapper/>
            <div className={HeaderWrapper}>
                <h1>KPI</h1>
            </div>
            <a className={DownloadButton} href={"https://" + currentHost + "/portail/edito/documents/MPB30478KRI4T.pdf"} target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 4ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href={"https://" + currentHost + "/portail/edito/documents/MPB30478KRI3T.pdf"} target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 3ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href={"https://" + currentHost + "/portail/edito/documents/MPB30478KRI2T.pdf"} target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 2ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href={"https://" + currentHost + "/portail/edito/documents/MPB30478KRI1T.pdf"} target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 1er trimestre <span
                className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
        </div>
    )
}

export default Kpi;